import React, { useState } from 'react';
import { Accordion, Box } from '@chakra-ui/react';

import { SenseNotConnectedAlert } from '../SenseNotConnectedAlert';
import { Weather } from '../Weather';
import { WelcomeMessage } from '../WelcomeMessage';
import { PowerChart } from './power-chart/PowerChart';
import { PowerConsumers } from './power-consumers/PowerConsumers';
import { PowerModes } from './power-modes/PowerModes';
import { PowerSources } from './power-sources/PowerSources';
import { SummaryInfo } from './summary-info/SummaryInfo';
import { TopPowerConsumers } from './top-power-consumers/TopPowerConsumers';

// This is the home page for Sense-only sites
export function SenseOnlyHome() {
  const [isDialChartSelected, setSelectedDialChart] = useState<boolean>(true);

  const handleSelectedDialChart = (value: boolean) => {
    setSelectedDialChart(value);
  };

  return (
    <Box data-testid="sense-only-home-page">
      <SenseNotConnectedAlert />
      <Weather />
      <WelcomeMessage />
      <PowerChart onSelect={handleSelectedDialChart} isDialChartSelected={isDialChartSelected} />
      <SummaryInfo />
      <Accordion allowToggle>
        <PowerSources isDialChartSelected={isDialChartSelected} />
        <TopPowerConsumers isDialChartSelected={isDialChartSelected} />
        <PowerConsumers isDialChartSelected={isDialChartSelected} />
        <PowerModes />
      </Accordion>
    </Box>
  );
}
